import ContentLoader from "@stimulus-components/content-loader";

// Connects to data-controller="content-loader"
export default class extends ContentLoader {
  connect() {
    super.connect();
  }
}
